"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTiersList = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Returns a list of all game tiers.
 *
 * ## Usage
 *
 * ```ts
 * const tiers: Tier[] = await sdk.getTiersList({ });
 * ```
 */
const getTiersList = (_params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `${BASE_URL}/tiers/list`;
    const tierResponse = yield axios_1.default.post(url, {}, { validateStatus: () => true });
    const { status, data } = tierResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.getTiersList = getTiersList;
